import {
    faEnvelope,
    faHeart as faHeartBold,
    faTimes,
    faVenusMars,
    faAddressCard,
    faBars,
    faCamera,
    faCameraRetro,
    faClock,
    faCloudUploadAlt,
    faCog,
    faExternalLinkAlt,
    faGlobeAmericas,
    faHome,
    faInfoCircle,
    faLips,
    faLock,
    faLockOpen,
    faLockOpenAlt,
    faPhoneAlt,
    faPlusCircle,
    faQuestionCircle,
    faSignOutAlt,
    faSirenOn,
    faSort,
    faStar,
    faStars,
    faTags,
    faTrash,
    faTrashAlt,
    faUser,
    faUserCircle,
    faUsers,
    faAngleUp,
    faAngleDown,
    faAngleRight,
    faCheckCircle as faCheckCircleBold,
    faCheck,
    faAngleLeft,
    faChevronDown,
    faMinus,
    faPlus,
    faLocationCircle,
    faCopy as faCopyBold,
    faFilter,
    faCaretDown,
    faUserGroup as faUserFriendsBold,
    faShareAlt,
    faEuroSign,
    faSack,
    faCircle,
    faCommentsAlt,
    faArrowRight,
    faChevronRight as faChevronRightBold,
    faCreditCard as faCreditCardBold,
    faExclamationTriangle as faExclamationTriangleBold,
    faBan,
    faMinusCircle,
    faBoxOpen,
    faCrown,
    faBell,
    faPersonHalfDress,
    faHousePersonReturn,
    faPeopleRoof,
    faChildReaching,
    faBuildingColumns,
    faMapPin,
    faVideo,
    faUtensils,
    faReplyAll,
    faIdCard,
    faPhoneFlip,
    faPhone,
    faImage,
    faCalendar,
} from '@fortawesome/pro-solid-svg-icons'
import {
    faHeart,
    faCopy,
    faUserGroup as faUserFriends,
    faStars as faStarsRegular,
    faCheckCircle,
    faChevronRight,
    faCreditCard,
    faExclamationTriangle,
    faSpa,
} from '@fortawesome/pro-regular-svg-icons'
import {
    faWhatsapp,
    faFacebookF,
    faTwitter,
} from '@fortawesome/free-brands-svg-icons'

export const fa_venus_mars = () => {
    return getSvgIconPathData(faVenusMars);
}

export const fa_whatsapp = () => {
    return getSvgIconPathData(faWhatsapp);
}

export const fa_address_card = () => {
    return getSvgIconPathData(faAddressCard);
}

export const fa_bars = () => {
    return getSvgIconPathData(faBars);
}

export const fa_camera = () => {
    return getSvgIconPathData(faCamera);
}

export const fa_camera_retro = () => {
    return getSvgIconPathData(faCameraRetro);
}

export const fa_clock = () => {
    return getSvgIconPathData(faClock);
}

export const fa_cloud_upload_alt = () => {
    return getSvgIconPathData(faCloudUploadAlt);
}

export const fa_cog = () => {
    return getSvgIconPathData(faCog);
}

export const fa_external_link_alt = () => {
    return getSvgIconPathData(faExternalLinkAlt);
}

export const fa_globe_americas = () => {
    return getSvgIconPathData(faGlobeAmericas);
}

export const fa_home = () => {
    return getSvgIconPathData(faHome);
}

export const fa_info_circle = () => {
    return getSvgIconPathData(faInfoCircle);
}

export const fa_lips = () => {
    return getSvgIconPathData(faLips);
}

export const fa_lock = () => {
    return getSvgIconPathData(faLock);
}

export const fa_lock_open = () => {
    return getSvgIconPathData(faLockOpen);
}

export const fa_lock_open_alt = () => {
    return getSvgIconPathData(faLockOpenAlt);
}

export const fa_phone_alt = () => {
    return getSvgIconPathData(faPhone);
}

export const fa_plus_circle = () => {
    return getSvgIconPathData(faPlusCircle);
}

export const fa_question_circle = () => {
    return getSvgIconPathData(faQuestionCircle);
}

export const fa_sign_out_alt = () => {
    return getSvgIconPathData(faSignOutAlt);
}

export const fa_siren_on = () => {
    return getSvgIconPathData(faSirenOn);
}

export const fa_sort = () => {
    return getSvgIconPathData(faSort);
}

export const fa_star = () => {
    return getSvgIconPathData(faStar);
} //VELAAK

export const fa_stars = () => {
    return getSvgIconPathData(faStars);
}

export const fa_tags = () => {
    return getSvgIconPathData(faTags);
}

export const fa_trash = () => {
    return getSvgIconPathData(faTrash);
}

export const fa_trash_alt = () => {
    return getSvgIconPathData(faTrashAlt);
}

export const fa_user_circle = () => {
    return getSvgIconPathData(faUserCircle);
}

export const fa_users = () => {
    return getSvgIconPathData(faUsers);
}

export const fa_angle_up = () => {
    return getSvgIconPathData(faAngleUp);
}

export const fa_angle_down = () => {
    return getSvgIconPathData(faAngleDown);
}

export const fa_angle_right = () => {
    return getSvgIconPathData(faAngleRight);
}

export const fa_check_circle_bold = () => {
    return getSvgIconPathData(faCheckCircleBold);
}

export const fa_angle_left = () => {
    return getSvgIconPathData(faAngleLeft);
}

export const fa_chevron_down = () => {
    return getSvgIconPathData(faChevronDown);
}

export const fa_minus = () => {
    return getSvgIconPathData(faMinus);
}

export const fa_plus = () => {
    return getSvgIconPathData(faPlus);
}

export const fa_location_circle = () => {
    return getSvgIconPathData(faLocationCircle);
}

export const fa_copy = () => {
    return getSvgIconPathData(faCopy);
}

export const fa_filter = () => {
    return getSvgIconPathData(faFilter);
}

export const fa_caret_down = () => {
    return getSvgIconPathData(faCaretDown);
}

export const fa_user_friends = () => {
    return getSvgIconPathData(faUserFriends);
}

export const fa_facebook_f = () => {
    return getSvgIconPathData(faFacebookF);
}

export const fa_twitter = () => {
    return getSvgIconPathData(faTwitter);
}

export const fa_share_alt = () => {
    return getSvgIconPathData(faShareAlt);
}

export const fa_user_friends_bold = () => {
    return getSvgIconPathData(faUserFriendsBold);
}

export const fa_copy_bold = () => {
    return getSvgIconPathData(faCopyBold);
}

export const fa_euro_sign = () => {
    return getSvgIconPathData(faEuroSign);
}

export const fa_sack = () => {
    return getSvgIconPathData(faSack);
}

export const fa_circle = () => {
    return getSvgIconPathData(faCircle);
}

export const fa_comments_alt = () => {
    return getSvgIconPathData(faCommentsAlt);
}

export const fa_arrow_right = () => {
    return getSvgIconPathData(faArrowRight);
}

export const fa_chevron_right = () => {
    return getSvgIconPathData(faChevronRight);
}

export const fa_chevron_right_bold = () => {
    return getSvgIconPathData(faChevronRightBold);
}

export const fa_credit_card = () => {
    return getSvgIconPathData(faCreditCard);
}

export const fa_credit_card_bold = () => {
    return getSvgIconPathData(faCreditCardBold);
}

export const fa_ban = () => {
    return getSvgIconPathData(faBan);
}

export const fa_minus_circle = () => {
    return getSvgIconPathData(faMinusCircle);
}

export const fa_box_open = () => {
    return getSvgIconPathData(faBoxOpen);
}

export const fa_crown = () => {
    return getSvgIconPathData(faCrown);
}

export const fa_bell = () => {
    return getSvgIconPathData(faBell);
}

export const fa_person_half_dress = () => {
    return getSvgIconPathData(faPersonHalfDress);
}

export const fa_house_person_return = () => {
    return getSvgIconPathData(faHousePersonReturn);
}

export const fa_people_roof = () => {
    return getSvgIconPathData(faPeopleRoof);
}

export const fa_child_reaching = () => {
    return getSvgIconPathData(faChildReaching);
}

export const fa_building_columns = () => {
    return getSvgIconPathData(faBuildingColumns);
}

export const fa_map_pin = () => {
    return getSvgIconPathData(faMapPin);
}

export const fa_spa = () => {
    return getSvgIconPathData(faSpa);
}

export const fa_utensils = () => {
    return getSvgIconPathData(faUtensils);
}

export const fa_reply_all = () => {
    return getSvgIconPathData(faReplyAll);
}

export const fa_id_card = () => {
    return getSvgIconPathData(faIdCard);
}

export const fa_video = () => {
    return getSvgIconPathData(faVideo);
}

export const fa_heart = () => {
    return getSvgIconPathData(faHeart);
}

export const fa_times = () => {
    return getSvgIconPathData(faTimes);
}

export const fa_user = () => {
    return getSvgIconPathData(faUser);
}

export const fa_heart_bold = () => {
    return getSvgIconPathData(faHeartBold);
}

export const fa_check_circle = () => {
    return getSvgIconPathData(faCheckCircle);
}

export const fa_check = () => {
    return getSvgIconPathData(faCheck);
}

export const fa_stars_regular = () => {
    return getSvgIconPathData(faStarsRegular);
}

export const fa_exclamation_triangle_bold = () => {
    return getSvgIconPathData(faExclamationTriangleBold);
}

export const fa_exclamation_triangle_regular = () => {
    return getSvgIconPathData(faExclamationTriangle);
}

export const fa_calendar = () => {
    return getSvgIconPathData(faCalendar);
}

export const fa_phone = () => {
    return getSvgIconPathData(faPhone);
}

export const fa_envelope = () => {
    return getSvgIconPathData(faEnvelope);
}

export const vip_user_icon = () => {
    return {
        width: 512,
        height: 512,
        path: "M 300.78 -84.88 c 69.66 21.06 110.7 49.68 134.46 93.42 c 22.68 41.04 24.84 86.4 6.48 141.48 c -7.56 23.22 -14.04 53.46 -14.04 68.04 c 0 15.66 -3.24 28.62 -7.56 32.4 c -4.32 3.24 -10.26 16.74 -13.5 29.7 c -11.88 46.98 -47.52 69.66 -91.26 57.24 c -28.08 -7.56 -37.26 -16.2 -54.54 -49.68 c -8.1 -15.66 -18.36 -28.62 -22.68 -28.62 c -4.32 0 -12.42 10.26 -18.36 22.68 c -23.22 47.52 -57.78 66.96 -99.36 55.62 c -24.84 -6.48 -41.04 -24.84 -50.22 -56.16 c -3.24 -11.88 -9.18 -25.92 -13.5 -30.78 c -3.78 -4.32 -7.02 -12.42 -7.02 -17.28 c -0 -5.4 -8.64 -27.54 -19.44 -49.14 c -23.76 -49.68 -28.62 -86.94 -16.2 -128.52 c 8.64 -30.24 32.4 -58.32 49.14 -58.32 c 3.78 -0 15.12 9.18 24.3 19.98 l 17.28 20.52 l -11.34 -21.6 c -6.48 -11.88 -11.34 -26.46 -11.34 -32.94 c -0 -18.36 22.68 -46.98 48.6 -61.56 c 21.06 -11.34 32.4 -13.5 81 -14.58 c 42.12 -1.08 64.8 1.08 89.1 8.1 z m -183.6 145.26 c 7.56 11.34 13.5 22.14 13.5 23.76 c 0 2.16 -7.56 4.86 -17.28 7.02 c -35.64 7.02 -43.74 22.14 -49.68 92.34 l -2.7 32.4 l 49.68 -0 c 27.54 -0 67.5 3.24 88.56 7.56 c 34.02 6.48 44.82 6.48 78.3 -0 c 21.6 -4.32 61.56 -7.56 88.56 -7.56 l 49.14 -0 l -2.7 -40.5 c -2.7 -48.6 -11.88 -68.58 -35.1 -77.76 c -29.7 -12.42 -188.46 -21.06 -212.76 -12.42 c -10.26 3.78 -16.2 0.54 -35.1 -19.98 c -12.96 -13.5 -23.76 -24.84 -24.84 -24.84 c -0.54 0 4.86 9.18 12.42 19.98 z M 63.18 337.4 c 2.16 5.94 12.96 22.14 24.84 35.64 c 23.76 27.54 42.66 61.02 42.66 76.14 c 0 7.56 3.78 5.4 14.04 -8.1 c 42.66 -54 147.42 -54.54 186.84 -1.08 l 11.88 16.74 l 7.02 -24.3 c 4.32 -13.5 17.28 -35.1 31.32 -50.76 c 13.5 -14.58 26.46 -32.4 29.16 -39.42 c 4.86 -11.88 5.4 -10.8 5.4 7.02 c 0.54 11.34 -2.7 30.78 -7.02 43.2 c -4.32 12.96 -10.26 36.18 -13.5 51.84 c -3.24 15.66 -9.18 35.1 -13.5 43.2 c -12.96 24.84 -58.86 64.8 -83.7 73.98 c -28.62 9.72 -92.88 10.26 -120.96 0.54 c -19.98 -7.56 -65.34 -44.28 -79.38 -65.34 c -11.34 -16.74 -46.98 -163.08 -41.04 -169.02 c 1.08 -1.08 3.78 3.24 5.94 9.72 z m 113.4 110.16 c -47.52 19.98 -32.94 78.3 19.98 81 c 16.74 0.54 17.82 -0.54 16.2 -16.74 c -1.62 -14.58 -0 -17.82 11.88 -21.06 c 7.56 -1.62 20.52 -1.62 28.08 -0 c 11.88 3.24 13.5 6.48 11.88 21.06 c -1.62 16.2 -0.54 17.28 16.2 16.74 c 51.84 -2.7 67.5 -60.48 21.06 -80.46 c -23.22 -10.26 -100.98 -10.26 -125.28 -0.54 z"
    };
}

export const custom_message_bubble = () => {
    return {
        width: 20,
        height: 20,
        path: 'M8.333 2.5h3.334a6.667 6.667 0 1 1 0 13.333v2.917c-4.167-1.667-10-4.167-10-9.583A6.667 6.667 0 0 1 8.333 2.5Z',
    };
};

export const custom_media_image = () => {
    return {
        width: 20,
        height: 20,
        path: 'm4.167 9.25 1.666-1.666 4.584 4.583 2.916-2.917 2.5 2.5V4.167H4.167V9.25ZM3.333 2.5h13.334c.46 0 .833.373.833.833v13.334c0 .46-.373.833-.833.833H3.333a.833.833 0 0 1-.833-.833V3.333c0-.46.373-.833.833-.833Zm9.584 5.833a1.25 1.25 0 1 1-.002-2.498 1.25 1.25 0 0 1 .002 2.498Z',
    };
};

export const custom_user = () => {
    return {
        width: 16,
        height: 21,
        path: "M16 21H14V19C14 17.3431 12.6569 16 11 16H5C3.34315 16 2 17.3431 2 19V21H0V19C0 16.2386 2.23858 14 5 14H11C13.7614 14 16 16.2386 16 19V21ZM8 12C4.68629 12 2 9.3137 2 6C2 2.68629 4.68629 0 8 0C11.3137 0 14 2.68629 14 6C14 9.3137 11.3137 12 8 12ZM8 10C10.2091 10 12 8.20914 12 6C12 3.79086 10.2091 2 8 2C5.79086 2 4 3.79086 4 6C4 8.20914 5.79086 10 8 10Z"
    };
}

export const hamburger = () => {
    return {
        width: 18,
        height: 16,
        path: "M0 0H18V2H0V0ZM0 7H18V9H0V7ZM0 14H18V16H0V14Z"
    };
}

export const close = () => {
    return {
        width: 14,
        height: 14,
        path: "M7.0007 5.5865L11.9504 0.636719L13.3646 2.05093L8.4149 7.0007L13.3646 11.9504L11.9504 13.3646L7.0007 8.4149L2.05093 13.3646L0.636719 11.9504L5.5865 7.0007L0.636719 2.05093L2.05093 0.636719L7.0007 5.5865Z"
    };
}

export const starCircle = () => {
    return {
        width: 24,
        height: 24,
        path: "M12 7a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 3.5-1.322 2.68-2.958.43 2.14 2.085-.505 2.946L12 17.25l2.645 1.39-.505-2.945 2.14-2.086-2.958-.43L12 10.5Zm1-8.501L18 2v3l-1.363 1.138A9.935 9.935 0 0 0 13 5.05L13 1.999Zm-2 0v3.05a9.935 9.935 0 0 0-3.636 1.088L6 5V2l5-.001Z"
    };
};

export const foldedMap = () => {
    return {
        width: 24,
        height: 24,
        path: "M3 5.7 9.3 3l5.4 2.7 5.673-2.431a.45.45 0 0 1 .627.413V18.3L14.7 21l-5.4-2.7-5.673 2.431A.45.45 0 0 1 3 20.317V5.7Zm11.7 13.288V7.658l-.058.025L9.3 5.013v11.329l.058-.025 5.342 2.67Z"
    };
};

export const alarm = () => {
    return {
        width: 17,
        height: 16,
        path: "M3.167 13.333v-4a5.333 5.333 0 1 1 10.667 0v4h.667v1.334h-12v-1.334h.666Zm1.334-4h1.333a2.667 2.667 0 0 1 2.667-2.666V5.333a4 4 0 0 0-4 4Zm3.333-8h1.334v2H7.834v-2Zm5.852 1.872.943.943-1.414 1.414-.943-.943 1.414-1.414Zm-11.313.943.942-.943L4.73 4.619l-.943.943-1.414-1.414Z"
    };
};

export const mapPin = () => {
    return {
        width: 12,
        height: 16,
        path: "M10.243 10.91 6 15.151l-4.243-4.243a6 6 0 1 1 8.486 0ZM6 8a1.333 1.333 0 1 0 0-2.667A1.333 1.333 0 0 0 6 8Z"
    };
};

export const checkBadge = () => {
    return {
        width: 12,
        height: 12,
        path: "M7.385.542a2.266 2.266 0 0 0-2.94 0c-.363.31-.815.496-1.29.534-1.11.089-1.99.97-2.08 2.08a2.27 2.27 0 0 1-.534 1.29 2.268 2.268 0 0 0 0 2.942c.31.364.497.815.535 1.291a2.267 2.267 0 0 0 2.079 2.08c.475.038.927.225 1.29.534a2.266 2.266 0 0 0 2.94 0c.363-.31.814-.496 1.29-.534a2.267 2.267 0 0 0 2.079-2.08 2.27 2.27 0 0 1 .534-1.29 2.268 2.268 0 0 0 0-2.942 2.27 2.27 0 0 1-.534-1.291 2.267 2.267 0 0 0-2.08-2.08 2.266 2.266 0 0 1-1.29-.534ZM4.459 5.625c.4.397 1.045.397 1.445 0l1.678-1.67a.723.723 0 1 1 1.02 1.026L6.206 7.364a1.454 1.454 0 0 1-2.05 0l-.93-.925a.723.723 0 1 1 1.02-1.026l.213.212Z"
    };
};

export const fa_image = () => {
    return getSvgIconPathData(faImage);
}

export const fa_video_play = () => {
    return {
        width: 17,
        height: 16,
        path: 'M11.167 2.667c.368 0 .666.298.666.666v2.8L15.31 3.7a.333.333 0 0 1 .524.274v8.053a.333.333 0 0 1-.524.273l-3.476-2.433v2.8a.667.667 0 0 1-.666.666H1.833a.667.667 0 0 1-.666-.666V3.333c0-.368.298-.666.666-.666h9.334ZM5.433 5.886a.267.267 0 0 0-.261.213l-.005.053v3.696a.267.267 0 0 0 .361.249l.048-.024L8.48 8.225a.267.267 0 0 0 .042-.417l-.042-.033-2.904-1.848a.267.267 0 0 0-.143-.041Z',
        pathFill: 'url(#video-play-gradient)',
        defs: '<linearGradient id="video-play-gradient" x1="-1.826" x2="31.82" y1="2.063" y2="3.314" gradientUnits="userSpaceOnUse"><stop stop-color="#E7407C"></stop><stop offset="1" stop-color="#EF805E"></stop></linearGradient>',
    };
};

export const fa_gem = () => {
    return {
        width: 32,
        height: 32,
        path: 'M7.583 5.991h16.834c.378 0 .733.18.955.483l4.515 6.163a.583.583 0 0 1-.044.743l-13.41 14.422a.594.594 0 0 1-.867 0L2.156 13.38a.583.583 0 0 1-.043-.743l4.515-6.163c.222-.303.577-.483.955-.483Z',
        pathFill: 'url(#gem-gradient)',
        defs: '<linearGradient id="gem-gradient" x1="-1.826" x2="31.82" y1="2.063" y2="3.314" gradientUnits="userSpaceOnUse"><stop stop-color="#E7407C"></stop><stop offset="1" stop-color="#EF805E"></stop></linearGradient>',
    };
};

export const checkmarkDouble = () => {
    return {
        width: 16,
        height: 16,
        path: 'm7.735 9.173.941.942L14.32 4.47l.943.943L8.676 12 4.433 7.758l.943-.943L6.793 8.23l.942.942Zm0-1.885 3.303-3.302.94.94-3.302 3.302-.94-.94Zm-1.884 3.77L4.91 12 .667 7.758l.943-.943.942.942H2.55l3.3 3.301Z',
        pathFill: '#51B722',
    };
};

export const magicWand = () => {
    return {
        width: 14,
        height: 14,
        path: 'm9.15 9.339-1.476 3.1a.4.4 0 0 1-.651.103l-2.361-2.493a.4.4 0 0 0-.239-.121L1.02 9.483a.4.4 0 0 1-.3-.588l1.642-3.016a.4.4 0 0 0 .041-.264L1.774 2.24a.4.4 0 0 1 .466-.467l3.375.63a.4.4 0 0 0 .265-.043L8.895.72a.4.4 0 0 1 .588.299l.445 3.404a.4.4 0 0 0 .122.239l2.492 2.36a.4.4 0 0 1-.103.652l-3.1 1.475a.4.4 0 0 0-.19.19Zm.53 1.284.944-.943 2.828 2.829-.943.943-2.828-2.829Z',
    };
};

export const messageTyping = () => {
    return {
        width: 17,
        height: 16,
        path: 'M5.136 12.667 2.166 15V2.667c0-.369.3-.667.667-.667h12c.369 0 .667.298.667.667V12a.667.667 0 0 1-.667.667H5.136Zm.364-6V8h1.333V6.667H5.5Zm2.667 0V8H9.5V6.667H8.167Zm2.666 0V8h1.334V6.667h-1.334Z',
    };
};

export const erobellaE = () => {
    return {
        width: 20,
        height: 22,
        path: 'M18.7183 0V5.28371H18.3114C18.2059 4.93406 18.0297 4.48522 17.7792 3.93879C17.5288 3.394 17.1796 2.86221 16.7298 2.34831C16.2801 1.83279 15.7018 1.38557 14.9934 1.0034C14.2834 0.622856 13.4168 0.430958 12.3954 0.430958H7.41845V9.97871H9.17134C9.94234 9.97871 10.5964 9.86975 11.1285 9.65509C11.6606 9.43879 12.1038 9.1298 12.458 8.72812C12.8122 8.32643 13.1038 7.84344 13.3344 7.27587C13.5634 6.70993 13.7512 6.07569 13.8979 5.37478H14.3048V14.9843H13.8979C13.7512 14.3875 13.5799 13.8102 13.3806 13.254C13.1812 12.6978 12.916 12.2083 12.5832 11.7871C12.2488 11.3659 11.8369 11.0293 11.346 10.7821C10.855 10.5349 10.2455 10.4113 9.51565 10.4113H7.41845V21.5658H12.5519C13.5107 21.5658 14.3773 21.4064 15.1499 21.0877C15.9209 20.7689 16.6046 20.3201 17.1993 19.7428C17.7941 19.1671 18.29 18.4922 18.6853 17.7197C19.0807 16.9472 19.3839 16.1178 19.5931 15.2331H20V22H0V21.5674H2.87974V0.432584H0V0H18.7183Z',
        pathFill: 'currentColor',
    };
};

export const telegram = () => {
    return {
        width: 17,
        height: 16,
        path: 'M8.5 14.667a6.667 6.667 0 1 1 0-13.334 6.667 6.667 0 0 1 0 13.334ZM6.428 8.78l.009-.006.58 1.914c.074.207.177.244.302.227.125-.017.191-.084.273-.163l.792-.765 1.7 1.258c.31.172.534.083.611-.288L11.8 5.744c.122-.485-.092-.68-.469-.526L4.843 7.725c-.443.178-.44.425-.08.536l1.664.52Z',
    };
};

export const whatsappIcon = () => {
    return {
        width: 16,
        height: 16,
        path: 'M8.00067 1.33337C11.6825 1.33337 14.6673 4.31814 14.6673 8.00004C14.6673 11.6819 11.6825 14.6667 8.00067 14.6667C6.77807 14.6667 5.63234 14.3376 4.64724 13.7632L1.33677 14.6667L2.23808 11.3544C1.66329 10.3691 1.33398 9.22304 1.33398 8.00004C1.33398 4.31814 4.31875 1.33337 8.00067 1.33337ZM5.59488 4.87226C5.50862 4.87832 5.42404 4.89939 5.34704 4.93878C5.28928 4.96833 5.23565 5.01105 5.15139 5.09061C5.07182 5.16574 5.02571 5.23135 4.97712 5.29461C4.73066 5.61551 4.59819 6.00941 4.60065 6.41403C4.60199 6.74111 4.68695 7.05897 4.82112 7.35577C5.09321 7.95764 5.54192 8.59391 6.13462 9.18397C6.277 9.32571 6.41648 9.46897 6.56689 9.60137C7.30253 10.2491 8.1792 10.7162 9.12713 10.9655C9.12713 10.9655 9.50046 11.0228 9.50593 11.0232C9.6296 11.0298 9.75306 11.0209 9.87686 11.0146C10.0711 11.0046 10.2607 10.952 10.4323 10.8606C10.5426 10.8019 10.5948 10.7727 10.6874 10.7143C10.6874 10.7143 10.7158 10.6951 10.7706 10.6543C10.8606 10.5872 10.9162 10.54 10.9911 10.4623C11.0463 10.405 11.0937 10.3372 11.1304 10.2609C11.1825 10.1521 11.235 9.94444 11.2559 9.77197C11.2718 9.64024 11.267 9.56824 11.2653 9.52364C11.2624 9.45191 11.2031 9.37811 11.1382 9.34677L10.7505 9.17251C10.7505 9.17251 10.1709 8.92024 9.81633 8.75851C9.7794 8.74164 9.739 8.73384 9.6984 8.73137C9.60946 8.72591 9.5098 8.74911 9.4464 8.81591C9.44306 8.81457 9.39893 8.85271 8.9166 9.43704C8.89 9.46884 8.82766 9.53797 8.71986 9.53151C8.7036 9.53037 8.6874 9.52804 8.6716 9.52391C8.62793 9.51237 8.5854 9.49717 8.5438 9.47957C8.46133 9.44457 8.4324 9.43131 8.37606 9.40704C7.9912 9.23891 7.638 9.01397 7.3258 8.73871C7.24206 8.66497 7.1642 8.58557 7.08393 8.50777C6.8038 8.23624 6.57446 7.94744 6.40384 7.66257C6.39453 7.64704 6.38018 7.62457 6.36472 7.59944C6.3368 7.55404 6.30602 7.50004 6.29636 7.46297C6.27158 7.36491 6.33732 7.28611 6.33732 7.28611C6.33732 7.28611 6.49959 7.10871 6.57498 7.01224C6.64752 6.91937 6.71013 6.82857 6.75 6.76384C6.82853 6.63759 6.8534 6.50712 6.81213 6.40646C6.62509 5.95047 6.43212 5.49695 6.23324 5.046C6.19398 4.95701 6.07723 4.89235 5.97106 4.88009C5.9351 4.87593 5.89916 4.87176 5.86306 4.86939C5.77368 4.86503 5.68413 4.86599 5.59488 4.87226Z',
    };
};

export const houseIcon = () => {
    return {
        width: 16,
        height: 16,
        path: 'M14 13.3331C14 13.7013 13.7015 13.9998 13.3333 13.9998H2.66667C2.29848 13.9998 2 13.7013 2 13.3331V6.32589C2 6.12016 2.09498 5.92596 2.25737 5.79965L7.59073 1.65151C7.83147 1.46427 8.16853 1.46427 8.40927 1.65151L13.7426 5.79965C13.905 5.92596 14 6.12016 14 6.32589V13.3331Z',
        pathFill: 'url(#house-icon-gradient)',
        defs: '<linearGradient id="house-icon-gradient" x1="8" y1="1.51108" x2="8" y2="13.9998" gradientUnits="userSpaceOnUse"><stop stop-color="#E94978"></stop><stop offset="1" stop-color="#EF7C61"></stop></linearGradient>',
    };
};

export const cardIcon = () => {
    return {
        width: 48,
        height: 48,
        path: 'M42 26v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V26H4v-4l2-10h36l2 10v4h-2Zm-32 0v12h28V26H10Zm2 2h16v6H12v-6ZM6 6h36v4H6V6Z',
        pathFill: 'url(#card-icon-gradient)',
        defs: '<linearGradient id="card-icon-gradient" x1="24" x2="24" y1="6" y2="42" gradientUnits="userSpaceOnUse"><stop stop-color="#EA4C78"></stop><stop offset="1" stop-color="#F07964"></stop></linearGradient>',
    };
};

export const cardIconAlt = () => {
    return {
        width: 48,
        height: 48,
        path: 'M42 26v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V26H4v-4l2-10h36l2 10v4h-2Zm-32 0v12h28V26H10Zm2 2h16v6H12v-6ZM6 6h36v4H6V6Z',
        pathFill: 'url(#card-icon-gradient-alt)',
        defs: '<linearGradient id="card-icon-gradient-alt" x1="24" x2="24" y1="6" y2="42" gradientUnits="userSpaceOnUse"><stop stop-color="#EA4C78"></stop><stop offset="1" stop-color="#F07964"></stop></linearGradient>',
    };
};

export const imageIcon = () => {
    return {
        width: 48,
        height: 48,
        path: 'm10 22.201 4-4 11 11 7-7 6 6V10H10v12.201ZM8 6h32a2 2 0 0 1 2 2v32a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Zm23 14a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z',
        pathFill: 'url(#image-icon-gradient)',
        defs: '<linearGradient id="image-icon-gradient" x1="24" x2="24" y1="6" y2="42" gradientUnits="userSpaceOnUse"><stop stop-color="#EA4C78"></stop><stop offset="1" stop-color="#F07964"></stop></linearGradient>',
    };
};

export const agencyIcon = () => {
    return {
        width: 296,
        height: 295,
        path: 'M123.5 7.4c-11.4 2.7-16.3 4.5-25.5 9.4C76.6 28.2 62.3 43 51.9 64.3 46 76.6 43 87.8 43 97.6v7.3l-4.6 2.3c-14.3 7.1-20 27-12.3 43.1 3.3 7 8.2 12.6 13.3 15.2 4.3 2.1 6.3 2.5 14.5 2.5h9.4l-.6-20.3c-.4-11.1-.7-25.7-.7-32.5V103h-4c-2.7 0-4.3-.5-4.6-1.5-1.3-3.3 3.6-22.9 8-32 18.2-37.9 59.7-59.5 99.7-51.9 17.4 3.3 35.2 12.8 48.4 25.8 14.4 14.3 24.6 35.5 25.7 53.6l.3 5.5-4.1.3-4.1.3-.6 21.7c-.4 11.9-.7 26.8-.7 33V169l4-.6c3.5-.6 4-.4 4 1.2-.1 3.4-3.7 10-7.5 13.9-7.1 7-21.3 11.5-36.4 11.5-13 0-17-.9-18.6-4.1-1.9-3.6-7.2-5.3-13.9-4.6-4.3.5-5.7 1.3-9 4.8-3.6 3.8-3.8 4.4-3.4 9 .8 8 6 11.9 15.8 11.9 4 0 5.6-.5 7.5-2.4 2.2-2.2 3.1-2.4 19.2-2.9 17.7-.5 23.8-1.8 35.3-7.7 9.6-4.9 22-20.3 22-27.4 0-4.4 1.2-6.5 3.9-7.1 3.7-.8 11.5-8.9 14-14.5 5.4-12.3 2.8-27.6-6.4-37.9-1.9-2-5-4.6-6.9-5.6-3.5-1.9-3.6-2.2-3.6-7.5-.1-14.4-7.5-35.7-17.9-50.7-8.7-12.8-25.2-26.1-42.3-34.3-12.7-6.1-21.9-8.2-38.3-8.6-12.1-.3-15.3-.1-24 2zM135.2 29.1c-28.1 4.9-52 25.8-59.9 52.4-3.3 11.2-2.4 69.9 1.2 76.4 2.7 4.9 3.5 6.6 6.4 14.6 3.6 9.6 11.9 24.2 17.3 30.7l3.9 4.7-1.1 8.8c-1.6 13.2-1.8 13.8-6.7 19.3-5.7 6.4-10.8 8.9-26.4 13.5-6.8 2-15.8 5.3-19.9 7.3-13.8 6.7-25.6 21.2-27.6 33.9l-.7 4.3h55.1c30.3 0 55.2-.3 55.4-.8.2-.4 3.1-3.4 6.5-6.6l6.2-5.9 7.2 6.6 7.1 6.7h108.1l-.7-4.3c-1.3-8-7-18-14.1-24.5-8.3-7.6-14.8-11-31.9-16.7-14.4-4.7-19-6.9-23.9-11.4-4.8-4.4-6.8-7.8-8.1-14.3l-1.3-6.2-9.4.2c-10.7.3-14.2.8-21.8 2.9-11.3 3.2-23.6 0-33.3-8.6-6.8-6.1-18.5-22-24.1-32.8-8.3-16.1-12.7-33.2-12.7-49.4 0-5.4.2-5.7 2.7-6.4 4.2-1 15.8-9.1 20-14 4.2-4.7 9.3-14.2 9.3-17.3 0-1.1-1.4-5.3-3.1-9.3-4.1-9.4-5.2-20.8-2.4-23.9 1-1.1 2.4-2 3.1-2 .7 0 2.7 4.3 4.5 9.7 1.8 5.4 5.7 14.7 8.8 20.8 9.1 18 20.4 27.9 40.1 35 6.3 2.3 9.7 2.8 20.9 3.3l13.4.5-.6 10.6c-.7 11.9-4.5 25.7-10.2 37.1-5.1 10.3-5.2 10.7-1 11.4 2 .4 4.5.4 5.5.1 2.2-.7 7.7-10 11-18.5 1.2-3 2.7-6 3.5-6.6 2.1-1.6 3.3-11.5 4.1-33.2l.7-19.3-3.9 1.6c-5.6 2.5-22.8 2.5-31.4.1-17.4-5-32.3-17.2-40-32.7-4.9-10.1-6.1-16.7-3.5-18.9 2.1-1.8 3.1-.7 10.8 12 13.4 21.7 42.7 35.6 62.7 29.6 4.4-1.3 4.5-1.4 4.8-5.8.7-10.3-6-27.5-14.7-38-15.9-19.3-43.9-30.6-65.9-26.7zm-17.6 194c5 5.5 18.8 10.9 27.9 10.9 7.9 0 20.2-4.2 25.4-8.6 2.3-2 4.6-3.3 5-2.8.4.5 1.5 3.8 2.5 7.3l1.7 6.4-3.8 4c-6.6 7-14.1 13.8-22.4 20.3l-8 6.3-8.2-6.1c-8.8-6.5-18-15-22.8-21l-3-3.8 1.2-7.5c.7-4.1 1.6-7.5 1.9-7.5.4 0 1.5.9 2.6 2.1zm9.1 42.9c3.3 2.5 6.9 5 7.9 5.7 1.8 1.1 1.3 1.8-5.4 8.3-4.1 3.8-8 7-8.8 7-1.9 0-11.2-11.4-19.5-23.9L94 252.7l2.7-1.7c1.6-.9 3.6-2.7 4.7-3.8l1.9-2.2 8.7 8.3c4.7 4.5 11.4 10.3 14.7 12.7zm64.9-16.8c2.4 1.7 4.4 3.6 4.4 4.1 0 2.5-24.3 34.7-26.2 34.7-1.2 0-14.8-13-14.8-14.1 0-.5 5.3-5 11.8-10.2 6.4-5.1 13.3-11.2 15.2-13.4 1.9-2.3 3.9-4.2 4.3-4.2.5-.1 2.9 1.3 5.3 3.1zM213.1 178.7c-1.6 2.6-2.8 4.9-2.7 5.1.8.7 5.6-1.1 7.5-2.9 2.6-2.5 2.7-4.5.1-5.9-1.7-.9-2.3-.5-4.9 3.7zM70.7 182.5c-4.5 5.7-13.3 6.8-21 2.8-2.6-1.3-3.1-1.3-4.5 0-5.3 5.4 11.4 29.5 25.2 36.2 4.2 2 7.8 2.9 13 3.3 8.4.5 8.2.7 9.2-9.1l.6-6.3-5.1-5.9c-2.8-3.3-7.3-10.1-9.9-15.2l-4.8-9.2-2.7 3.4zM236 202.7c-.8.3-5.3 2.7-10 5.4-9.9 5.5-19.2 8.9-25 8.9-3.4 0-4 .3-4 2.1 0 4.4 1.8 5.9 6.9 5.9 9.9 0 21.6-5.6 29.9-14.3 6.1-6.5 7-9.7 2.2-8z',
    };
};

/**
 * Get the SVG icon path data for reactivity purposes.
 *
 * This function is used to retrieve the path data of an SVG icon for the purpose of maintaining reactivity.
 * When creating SVG icons through Unicode, they lose their reactivity. This function allows you to extract
 * the specific path data required for SVG reactivity.
 *
 * @param {Object} svg - The SVG object containing the icon data.
 * @returns {{path: *, width: *, height: *}} The path data of the SVG icon.
 */
function getSvgIconPathData(svg) {
    return {
        width: svg.icon[0],
        height: svg.icon[1],
        path: svg.icon[4],
    };
}
